const COGNITO_REGION = process.env.REACT_APP_AWS_PROJECT_REGION;

export default COGNITO_REGION;
